import { useEffect, useRef } from 'react'

const Confetti = ({ active = false, options = {} }) => {
    const confettiTriggered = useRef(false)

    const triggerConfetti = () => {
        const count = options.particleCount || 200
        const defaults = {
            origin: options.origin || { y: 0.7 },
        }

        function fire(particleRatio, opts) {
            const confetti = window.confetti
            if (confetti) {
                confetti({
                    ...defaults,
                    ...opts,
                    particleCount: Math.floor(count * particleRatio),
                })
            }
        }

        fire(0.25, {
            spread: 26,
            startVelocity: 55,
        })

        fire(0.2, {
            spread: 60,
        })

        fire(0.35, {
            spread: 100,
            decay: 0.91,
            scalar: 0.8,
        })

        fire(0.1, {
            spread: 120,
            startVelocity: 25,
            decay: 0.92,
            scalar: 1.2,
        })

        fire(0.1, {
            spread: 120,
            startVelocity: 45,
        })
    }

    useEffect(() => {
        if (active && !confettiTriggered.current) {
            confettiTriggered.current = true
            const delay = options.delay || 500
            setTimeout(() => {
                triggerConfetti()
            }, delay)
        }

        // Reset when active becomes false
        if (!active) {
            confettiTriggered.current = false
        }
        // eslint-disable-next-line
    }, [active, options.delay])

    return null // This component doesn't render anything
}

export default Confetti
